<template>
  <router-link :to="{ name: 'TeamSingle', params: { id: team.slug }}" class="team-card" v-bind:style="{ backgroundImage: 'url('+team.cover.url+')' }">
    <div class="team-content">
      <h4 v-html="team.name"></h4>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'TeamCard',
  props: {
    team: Object
  }
}
</script>

<style scoped lang="sass">
.team-card
  width: 350px
  height: 200px
  display: block
  margin: 0 0 5px
  
  transition: all .2s
  position: relative
  background-size: cover
  background-position: center

  @media (max-width: 600px)
    max-width: 100%

  &:hover
    color: black
    text-decoration: none
    .team-content
      background: rgba(0, 0, 0, .7)
      h4
        color: white
      
  .team-image
    width: 100%
    height: 180px
    overflow: hidden
    img
      width: auto
      height: 100%
      object-fit: cover
      transition: all .2s
    
  .team-content 
    width: 100%
    height: 100%
    padding: 20px
    color: #ccc !important
    background: rgba(0, 0, 0, .4)
    position: absolute
    top: 0
    left: 0

    h4
      font-weight: bold
      margin-bottom: 5px
      color: rgba(255, 255, 255, .6)
      transition: all .2s

</style>
